import { useMemo, useState } from 'react'
import { AdminPage, AdminPanel } from '@/components/Admin'
import { getTenantPortalAbsoluteUrl, getTenantSlug } from '@/config/tenant'
import { getAdminTenantSlug } from '@/utils/adminAuth'
import styles from './Admin.module.css'

function buildQrImageUrl(data: string, size = 480): string {
  const q = new URLSearchParams({
    size: `${size}x${size}`,
    data,
    margin: '16',
  })
  return `https://api.qrserver.com/v1/create-qr-code/?${q.toString()}`
}

export function AdminQrPage() {
  const slug = getTenantSlug() || getAdminTenantSlug()
  const portalUrl = useMemo(() => (slug ? getTenantPortalAbsoluteUrl(slug) : ''), [slug])
  const qrUrl = useMemo(() => (portalUrl ? buildQrImageUrl(portalUrl) : ''), [portalUrl])
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (!portalUrl) return
    try {
      await navigator.clipboard.writeText(portalUrl)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2000)
    } catch {
      setCopied(false)
    }
  }

  const handleDownload = () => {
    if (!qrUrl) return
    const a = document.createElement('a')
    a.href = qrUrl
    a.download = `gobooking-qr-${slug || 'espaco'}.png`
    a.target = '_blank'
    a.rel = 'noopener'
    a.click()
  }

  return (
    <AdminPage
      title="QR Code & link"
      subtitle="Partilhe o link do seu espaço na montra, no espelho ou no Instagram."
      wide
    >
      <AdminPanel
        title="Página pública do espaço"
        description="Quem lê o QR abre directamente o portal da sua marca — sem marketplace e sem concorrentes ao lado."
      >
        {!portalUrl ? (
          <p className={styles.listEmpty}>
            Não foi possível determinar o link do espaço. Entre pelo URL{' '}
            <code>/e/sua-empresa</code> ou contacte o suporte.
          </p>
        ) : (
          <>
            <div className={styles.formGroup}>
              <label htmlFor="qr-link">Link do espaço</label>
              <input id="qr-link" readOnly value={portalUrl} />
            </div>
            <div className={styles.formActions}>
              <button type="button" className={styles.btnSalvar} onClick={handleCopy}>
                {copied ? 'Copiado!' : 'Copiar link'}
              </button>
              <button type="button" className={styles.btnSecondary} onClick={handleDownload}>
                Transferir QR Code
              </button>
            </div>
            <div style={{ marginTop: 24, textAlign: 'center' }}>
              <img
                src={qrUrl}
                alt={`QR Code para ${portalUrl}`}
                width={280}
                height={280}
                style={{
                  maxWidth: '100%',
                  borderRadius: 16,
                  border: '1px solid var(--border, #e5e7eb)',
                  background: '#fff',
                }}
              />
              <p className={styles.pageHint} style={{ marginTop: 12 }}>
                Imprima e coloque na montra — cada leitura abre o seu espaço GoBooking.
              </p>
            </div>
          </>
        )}
      </AdminPanel>
    </AdminPage>
  )
}
